import './initalizer.js'
import './prefecture_selector/prefecture_selector.js'
import './prefecture_selector/prefecture_selector_popup.js'
import './shops/shoplist_select_prefecture.js'
import './search/item_search_result.js'
import './search/blog_search_result.js'
import './search/blog_search_result_smartphone.js'
import './index/top_keywords.js'
import './question/answer_like_btn'
